import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { routingConstants } from '../_constants/routing-constants.const';
import { AccessService } from '../_services/access.service';

// Runs after MsalGuard: the user is logged in, but may not have access to this tenant yet.
export const AccessGuard: CanActivateFn = () => {
  const accessService = inject(AccessService);
  const router = inject(Router);

  return accessService
    .getMe()
    .pipe(map((me) => (me.hasAccess ? true : router.createUrlTree([routingConstants.noAccess]))));
};

// Only users with the Entra Manager role, and only when the tenant has user management.
export const ManagerGuard: CanActivateFn = () => {
  const accessService = inject(AccessService);
  const router = inject(Router);

  return accessService.getMe().pipe(
    map((me) => {
      if (me.isManager && me.enabled) {
        return true;
      }
      return router.createUrlTree([me.hasAccess ? routingConstants.transcriber : routingConstants.noAccess]);
    }),
  );
};
